import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'AppIcon',
  props: {
  appID: {
    type: String,
    required: true,
  },
  width: {
    type: Number,
    default: 40,
  },
},
  setup(__props) {

const props = __props;

function imageURL(appID: string) {
  var result = "";
  if (appID) {
    result = "https://patch24content.j24.io/" + appID + ".png";
  }
  return result;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createBlock(_component_v_img, {
    src: imageURL(props.appID),
    width: props.width,
    "lazy-src": "https://patch24content.j24.io/placeholder.png"
  }, {
    placeholder: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        height: props.width,
        width: props.width,
        class: "d-flex justify-center align-center pa-0 ma-0",
        color: "grey-lighten-1",
        rounded: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("mdi-application-outline")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["height", "width"])
    ]),
    error: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        height: props.width,
        width: props.width,
        class: "d-flex justify-center align-center pa-0 ma-0",
        color: "grey-lighten-1",
        rounded: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("mdi-application-outline")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["height", "width"])
    ]),
    _: 1
  }, 8, ["src", "width"]))
}
}

})